const entranceId = state => state.entranceId;
const intercom = state => state.intercom;
const communityName = state => state.intercom?.communityName || state.intercom?.name;
const intercomName = state => state.intercom?.name;
const description = state => state.intercom?.description;
const address = state => state.intercom?.address;
const entranceStatus = state => state.entranceStatus;
const offices = state => state.offices;
const isVerified = state => Boolean(state.intercom);
const enabledForCommunity = state => state.intercom?.enabledForCommunity !== false;
const enabledForLocation = state => state.intercom?.enabledForLocation !== false;
const canCallResidents = (state, getters) =>
    getters.isVerified && getters.enabledForCommunity && getters.enabledForLocation;
const selectedResident = state => state.selectedResident;
const searchQuery = state => state.searchQuery;
const notice = state => state.notice;

export default {
    entranceId,
    intercom,
    communityName,
    intercomName,
    description,
    address,
    entranceStatus,
    offices,
    isVerified,
    enabledForCommunity,
    enabledForLocation,
    canCallResidents,
    selectedResident,
    searchQuery,
    notice,
};
